export default __webpack_public_path__ + "img/38dea067fd00d47773788af334543f31.png";